<template>
    <div>
        <div class="container" style="display: flex; align-items: flex-start; padding: 0 30px 30px">
            <div class="leftbox" style="width: 15%">
                <div class="titlea">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item> <i class="el-icon-setting"></i> 表格列设置 </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <ul>
                    <li class="leftColunm">
                        <span class="leftSpan tableHeadSpan">ID</span>
                        <span class="rgSpan tableHeadSpan">名称</span>
                        <span class="verticalLine"></span>
                    </li>
                    <li
                        v-for="(item, index) in selectList"
                        :key="index"
                        v-bind:class="{ bgSelect: item.id == current }"
                        class="leftColunm"
                        @click="selectValue(item.id, item.name)"
                    >
                        <span class="leftSpan">{{ item.id }}</span>
                        <span class="rgSpan">{{ item.name }}</span>
                        <span class="verticalLine"></span>
                    </li>
                </ul>
            </div>
            <div style="width: 85%">
                <div class="handle-box" style="display: flex; align-items: center; justify-content: space-between">
                    <div>
                        <el-select
                            v-model="selectId"
                            :disabled="isEditStatus"
                            filterable
                            placeholder="请选择"
                            class="handle-select mr10"
                            @change="selectValue"
                        >
                            <el-option v-for="(item, index) in selectList" :key="index" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                        <el-button type="text" style="color: red" @click="handleClick"> 【注意：本模块仅限工程师使用】 </el-button>
                    </div>

                    <div>
                        <el-button type="primary" v-if="isEditStatus" :disabled="!canOperate" @click="addTableData">{{ $t('common.add') }}</el-button>
                        <el-button v-if="isEditStatus" @click="optionCancel">{{ $t('common.cancel') }}</el-button>
                        <el-button type="primary" v-if="!isEditStatus" :disabled="isEditStatus" @click="handleAdd">{{ $t('common.edit') }}</el-button>
                        <el-button type="success" v-else :disabled="!isEditStatus" @click="preservation">{{ $t('common.save') }}</el-button>
                        <!-- <el-button type="success" :disabled="!isEditStatus" @click="tableDataStatus">批量显示</el-button> -->
                    </div>
                </div>
                <el-table
                    :data="tableData"
                    style="width: 100%"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                    :key="refushTable"
                >
                    <el-table-column type="index" title="序号" width="50" align="center">
                        <template slot="header">
                            <i class="el-icon-setting" style="font-size: 18px" @click.stop="changeTable()"></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="字段" align="center">
                        <template slot-scope="scope">
                            <el-input width="100px" :disabled="!isEditStatus || !canOperate" v-model="scope.row.field"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="字段名" align="center">
                        <template slot-scope="scope">
                            <el-input width="100px" :disabled="!isEditStatus || !canOperate" v-model="scope.row.field_name"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="字段状态" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.field_status === 1 ? 'success' : 'danger'">{{
                                scope.row.field_status === 1 ? '启用' : '停用'
                            }}</el-tag>
                            <el-switch
                                :disabled="!isEditStatus || !canOperate"
                                v-model="scope.row.field_status"
                                style="margin-left: 5px"
                                :active-value="1"
                                :inactive-value="0"
                                @change="handleFieldStatusChange(scope.row)"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否禁用" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.column_disabled === 1 ? 'success' : 'danger'">{{
                                scope.row.column_disabled === 1 ? '禁用' : '启用'
                            }}</el-tag>
                            <el-switch
                                :disabled="!isEditStatus"
                                v-model="scope.row.column_disabled"
                                style="margin-left: 5px"
                                :active-value="1"
                                :inactive-value="0"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="属性" align="center" >
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.attribute" placeholder="请选择" :disabled="!isEditStatus" clearable>
                                <el-option v-for="item in optionsAttribute" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="列名" align="center">
                        <template slot-scope="scope">
                            <el-input width="100px" :disabled="!isEditStatus" v-model="scope.row.column_name"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="英文列名" align="center">
                        <template slot-scope="scope">
                            <el-input width="100px" :disabled="!isEditStatus" v-model="scope.row.column_name_en" placeholder="English"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="繁体列名" align="center">
                        <template slot-scope="scope">
                            <el-input width="100px" :disabled="!isEditStatus" v-model="scope.row.column_name_zh_tw" placeholder="繁體中文"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="列宽" align="center">
                        <template slot-scope="scope">
                            <el-input width="100px" :disabled="!isEditStatus" v-model="scope.row.column_width"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否显示" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.column_status === 1 ? 'success' : 'danger'">{{
                                scope.row.column_status === 1 ? '显示' : '隐藏'
                            }}</el-tag>
                            <el-switch
                                :disabled="!isEditStatus"
                                v-model="scope.row.column_status"
                                style="margin-left: 5px"
                                :active-value="1"
                                :inactive-value="0"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="类型" align="center">
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.column_type"
                                placeholder="请选择"
                                :disabled="!isEditStatus"
                                @change="handleBatchChange(scope.row)"
                            >
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="精度类型" align="center">
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.tofixed"
                                placeholder="请选择"
                                :disabled="!isEditStatus || scope.row.column_type != 'number'"
                                clearable
                            >
                                <el-option v-for="item in optionsType" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否批量" align="center" >
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.batch === 1 ? 'success' : 'danger'">{{
                                scope.row.batch === 1 ? '是' : '否'
                            }}</el-tag>
                            <el-switch
                                :disabled="!isEditStatus || (scope.row.column_type !== 'number' && scope.row.column_type !== 'text')"
                                v-model="scope.row.batch"
                                style="margin-left: 5px"
                                :active-value="1"
                                :inactive-value="0"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center">
                        <template slot-scope="scope">
                            <el-input width="100px" :disabled="!isEditStatus" v-model="scope.row.remark"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" :disabled="!isEditStatus" @click="handleUp(scope.$index)">上移</el-button>
                            <el-button type="text" :disabled="!isEditStatus" @click="handleDown(scope.$index)">下移</el-button>
                            <el-button type="text" :disabled="!isEditStatus || !canOperate" @click="delCurrentRow(scope.$index)"
                                >{{ $t('common.delete') }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { apiGetMainTypeList, apiGetListCorrespondingSetData, apiSetListCorrespondingData, apiCurrentPermisson } from '@/request/api';
export default {
    name: 'tablecolumn',
    data() {
        return {
            drawers: false,
            direction: 'rtl',
            keyList: [],
            showIndex: null,
            optionalIndex: null,
            refushTable: true,

            selectList: [],
            tableData: [],
            perData: '',
            current: 0,
            selectId: 0,
            isEditStatus: false,
            options: [
                {
                    value: 'text',
                    label: '文本'
                },
                {
                    value: 'number',
                    label: '数字'
                },
                {
                    value: 'select',
                    label: '下拉'
                },
                {
                    value: 'image',
                    label: '图片'
                }
            ],
            optionsType: [
                { value: 'qty', label: '数量' },
                { value: 'wgt', label: '重量' },
                { value: 'prc', label: '单价' },
                { value: 'amt', label: '金额' },
                { value: 'rate', label: '税率' }
            ],
            optionsAttribute: [
                { value: 'default', label: '默认' },
                { value: 'cost', label: '成本' }
            ],
            // 点击十次才为true
            clickCount: 0,
            canOperate: false
        };
    },
    watch: {
        selectId: function (val, oldval) {
            this.getData();
        }
    },
    created() {
        this.canOperate = false;
        this.getListData();
        this.getPermission();
        this.current = 0;
    },
    methods: {
        tableDataStatus() {
            // 批量设置所有的 column_status 为 '1'（显示）
            this.tableData.forEach((row) => {
                row.column_status = 1;
            });
        },
        // 点击十次才为true
        handleClick() {
            this.clickCount++;
            if (this.clickCount >= 10) {
                this.canOperate = true;
            }
        },
        //列配置相关接口
        changeTable() {
            this.keyList = this.tableData;
            this.drawers = true;
        },

        keyConfirm() {
            this.refushTable = !this.refushTable;
            this.drawers = false;
            this.preservation();
        },

        keycancel() {
            this.drawers = false;
            this.getData();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', 0);
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', 1);
            }
        },
        checkMove(item) {},
        handleBatchChange(row) {
            if (row.column_type !== 'number' && row.column_type !== 'text') {
                row.batch = 0; // 强制将批量设置为0
            }
        },
        handleFieldStatusChange(row) {
            // 如果 field_status 被设置为 0，将 column_status 也同步设置为 0
            if (row.field_status === 0) {
                row.column_status = 0; // 设置 column_status 为 0
            }
        },
        handleUp(i) {
            this.tableData[i] = this.tableData.splice(i - 1, 1, this.tableData[i])[0];
        },
        handleDown(i) {
            this.tableData[i] = this.tableData.splice(i + 1, 1, this.tableData[i])[0];
        },
        // 获取左侧列表信息----------------------------------------------------------------------------------------------------
        getListData() {
            apiGetMainTypeList({}).then((res) => {
                if (res.code == 2000) {
                    this.selectList = res.data;
                    this.selectId = res.data[0].id;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取右侧表格信息----------------------------------------------------------------------------------------------------
        getData() {
            this.$load.show();
            apiGetListCorrespondingSetData({ id: this.selectId }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data;
                    // 为每条数据初始化多语言字段（如果不存在）
                    this.tableData.forEach(item => {
                        if (!item.column_name_en) {
                            item.column_name_en = '';
                        }
                        if (!item.column_name_zh_tw) {
                            item.column_name_zh_tw = '';
                        }
                    });
                    this.keyList = this.tableData;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //下拉选择----------------------------------------------------------------------------------------------------
        selectValue(number, name) {
            if (this.isEditStatus == true) {
                this.$message.info('请先退出编辑状态再进行切换');
                return;
            }
            this.selectId = number;
            this.current = number;
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '153'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 编辑----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.isEditStatus = true;
            // this.tableData.forEach((row) => {
            //     if (!row.attribute) {
            //         row.attribute = 'default'; // 如果没有值，设置为 'wgt'
            //     }
            // });
        },

        preservation() {
            this.$load.show();
            // this.tableData.forEach((row) => {
            //     if (!row.tofixed) {
            //         row.tofixed = 'wgt'; // 如果没有值，设置为 'wgt'
            //     }
            // });

            let data = {
                id: this.selectId,
                column: JSON.stringify(this.tableData)
            };
            apiSetListCorrespondingData(data).then((res) => {
                if (res.code === 2000) {
                    this.isEditStatus = false;
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.data.info);
                }
                this.$load.close();
            });
        },

        delCurrentRow(i) {
            this.$confirm('此操作将删除该行，是否继续？', '提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            }).then(() => {
                this.tableData.splice(i, 1);
            });
        },
        optionCancel() {
            this.getData();
            this.isEditStatus = false;
        },
        addTableData() {
            if (!this.tableData) {
                this.tableData = []; // 如果是 null，则初始化为一个空数组
            }
            let data = {};
            this.tableData.push(data);
        }
    }
};
</script>

<style scoped lang="scss">
.handle-box {
    /* margin-bottom: 20px; */
    height: 50px;
    line-height: 50px;
    text-align: right;
}

.handle-select {
    width: 250px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.leftColunm {
    display: flex;
    justify-content: space-between;
    text-align: center;
    position: relative;
    border-bottom: 1px solid #fff;
    .leftSpan {
        width: 30%;
    }
    .rgSpan {
        width: 70%;
    }
    .verticalLine {
        width: 1px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 32%;
        background-color: #fff;
    }
    .tableHeadSpan {
        font-weight: bold;
    }
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.titlea .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    height: 50px;
    line-height: 50px;
    color: #000;
    font-weight: bold;
    font-size: 16px;
}
.leftbox ul {
    background: #ecf5ff;
    height: 700px;
    overflow-y: scroll;
}
.leftbox ul li {
    list-style: none;
    padding: 10px;
    font-size: 14px;
}
/* .leftbox ul li:last-child{
    border-bottom: 1px solid skyblue;
} */
.bgSelect {
    background: #409eff;
    color: #fff;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
